export function getTemplateRenderer(postType) {
    const config = window.snapFindPublic;
    const templateString = config.frontend.templates[postType] || '';

    // Create a new function that takes `hit` and evaluates the JS literal body.
    let compiledFn;
    try {
        compiledFn = new Function('hit', `return \`${templateString}\``);
    } catch (e) {
        console.error('SnapFind Template Compilation Error:', e);
        compiledFn = (hit) =>
            `<div class="snaf-error">Error compiling template: ${e.message}</div>`;
    }

    return function render(hit, { html, components }) {
        try {
            const rawHTML = compiledFn(hit);
            const objectId = hit.id || hit.objectID || '';
            const position = hit.__position || '';
            // Return a plain HTML string — InstantSearch sets it as innerHTML directly.
            // We wrap the compiled template in a tracking div so analytics can reliably
            // read the product ID and position at click time without any post-render scan.
            return `<div class="snaf-hit-inner" data-snaf-id="${objectId}" data-snaf-pos="${position}">${rawHTML}</div>`;
        } catch (e) {
            console.error('SnapFind Template Render Error:', e);
            return `<div>Error rendering template.</div>`;
        }
    };
}
